export const CREATIVE_TYPE = [
  {
    label: 'Monthly',
    value: 'monthly_creatives',
  },
  {
    label: 'Adhoc',
    value: 'adhoc_creatives',
  },
];

export const MONTHS = [
  { label: 'Jan', value: 1 },
  { label: 'Feb', value: 2 },
  { label: 'Mar', value: 3 },
  { label: 'Apr', value: 4 },
  { label: 'May', value: 5 },
  { label: 'Jun', value: 6 },
  { label: 'Jul', value: 7 },
  { label: 'Aug', value: 8 },
  { label: 'Sep', value: 9 },
  { label: 'Oct', value: 10 },
  { label: 'Nov', value: 11 },
  { label: 'Dec', value: 12 },
];

export const YEAR = 2024;

export const FILTER_TYPES = {
  BRANCH: 'branch',
  YEAR: 'year',
  MONTH: 'month',
  CREATIVE_TYPE: 'creative_type',
};
